import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ENVIRONMENT } from 'shared';

/** A machine credential for the card partner's access to /api/remote/*. */
export interface PartnerApiToken {
  id: number;
  /** First 8 hex characters of the stored digest — matches what the rejection log prints. */
  fingerprint: string;
  partner: string;
  scopes: string[];
  description: string | null;
  created_by_id: number | null;
  created_by_email: string | null;
  expires_at: string;
  last_used_at: string | null;
  revoked_at: string | null;
  active: boolean;
  created_at: string;
}

export interface PartnerApiTokenCreateRequest {
  partner?: string;
  description?: string;
  scopes?: string[];
  expires_at?: string;
}

/** The raw token exists only in this response — we store nothing but its digest. */
export interface PartnerApiTokenCreateResponse {
  token: string;
  token_id: number;
  fingerprint: string;
  partner: string;
  scopes: string[];
  expires_at: string;
  message: string;
}

@Injectable({ providedIn: 'root' })
export class PartnerApiTokenService {
  private readonly apiUrl = this.environment.apiUrl || 'http://localhost:3000/api';
  private readonly base = `${this.apiUrl}/admin/partner-api-tokens`;

  constructor(private http: HttpClient, @Inject(ENVIRONMENT) private environment: any) {}

  getTokens(): Observable<{ tokens: PartnerApiToken[] }> {
    return this.http.get<{ tokens: PartnerApiToken[] }>(this.base);
  }

  createToken(request: PartnerApiTokenCreateRequest): Observable<PartnerApiTokenCreateResponse> {
    return this.http.post<PartnerApiTokenCreateResponse>(this.base, request);
  }

  revokeToken(id: number): Observable<{ message: string }> {
    return this.http.delete<{ message: string }>(`${this.base}/${id}`);
  }
}
